module.exports = __webpack_public_path__ + "img/heading4.2f813651.png";